import { CommandData } from "../../command/command";
import { GxmlCommand } from "./gxml-command";
export class MoveNodeCommand extends GxmlCommand {
    constructor(node, oldPosition, newPosition) {
        super();
        this._node = node;
        this._oldPosition = oldPosition;
        this._newPosition = newPosition;
    }
    get id() {
        return MoveNodeCommandData.ID;
    }
    get changeRoot() {
        return this._node;
    }
    do() {
        var _a;
        return (_a = this._node.parent) === null || _a === void 0 ? void 0 : _a.moveNode(this._node, this._newPosition);
    }
    undo() {
        var _a;
        return (_a = this._node.parent) === null || _a === void 0 ? void 0 : _a.moveNode(this._node, this._oldPosition);
    }
    getData() {
        return {
            id: this.id,
            nodeId: this._node.id,
            oldPosition: this._oldPosition,
            newPosition: this._newPosition
        };
    }
}
export var MoveNodeCommandData;
(function (MoveNodeCommandData) {
    MoveNodeCommandData.ID = 'MoveNode';
    function is(arg) {
        return CommandData.is(arg)
            && arg.id === MoveNodeCommandData.ID
            && 'nodeId' in arg
            && 'newPosition' in arg
            && 'oldPosition' in arg;
    }
    MoveNodeCommandData.is = is;
})(MoveNodeCommandData || (MoveNodeCommandData = {}));
//# sourceMappingURL=move-command.js.map